export const prevIndexUpdater = (listKey, indexKey, {reset = false} = {}) => (state) => {
    const size = state.get(listKey).size;
    const index = state.get(indexKey);
    const loopIndex = (!reset || index === -1) ? (size - 1) : -1;
    return state.set(indexKey, (index > 0) ? (index - 1) : loopIndex);
};

export const nextIndexUpdater = (listKey, indexKey, {reset = false} = {}) => (state) => {
    const size = state.get(listKey).size;
    const index = state.get(indexKey);
    const loopIndex = (!reset || index === -1) ? 0 : -1;
    return state.set(indexKey, (index < size - 1) ? (index + 1) : loopIndex);
};



// WEBPACK FOOTER //
// ./scripts/store/utils.js